export const releaseStage = () => {
  const { REACT_APP_RELEASE_STAGE } = process.env
  return REACT_APP_RELEASE_STAGE || 'development'
}
